import type { SpinResponse } from "@slot/client-engine";
import { fx, spinFixture } from "@slot/game-shell";

/**
 * The simplest reel spin: a single "reveal" event, no win.
 * spinBoundaryStart → (reel spin → stagger-stop) → spinBoundaryEnd.
 *
 * 5 reels (columns) × 4 visible rows — the game's `grid: { columns: 5, rows: 4 }`. The codec pads
 * or truncates a mismatch silently, so a fixture must author exactly this shape. Symbol ids are
 * catalog symbols (H1–H4 / L1–L5) plus a few FS/W scattered as visual filler.
 */
export function baseFixtureReelNoWin(): SpinResponse {
  return spinFixture("reel-no-win")
    .balance("EUR", "100000")
    .event("reveal", 0, (e) => {
      // Intentionally distinct from BOOT_FALLBACK_GRID so a spin is
      // visibly different from the boot board. Catalog-valid symbols
      // (H1–H4 / L1–L5) plus scattered FS/W as filler. No 3-in-a-row on any
      // line — presentation-only, no win.
      e.reelSet("default").accumulatedWinAfter("0").gridRows([
        ["L4", "L1", "L5", "L2", "H2"],
        ["L3", "W", "L4", "L1", "L5"],
        ["L1", "H4", "FS", "L2", "L5"],
        ["L2", "L3", "L4", "L4", "L1"],
      ]);

      const s = fx.spinBoundaryStart("base:1", "base");
      e.action(s.type, s.payload, { actionPhaseName: s.phase, debugTag: "start" });

      const end = fx.spinBoundaryEnd("base:1", "0");
      e.action(end.type, end.payload, { actionPhaseName: end.phase, debugTag: "end" });
    })
    .build();
}
